import { Box, Typography } from '@mui/material';
import React from 'react';
import { i18n } from '../../i18n/i18n';
import MuiDialogWrapper from '../../components/MuiDialogWrapper/MuiDialogWrapper';
import { IconStatusAlert } from '../../../common/images';

interface WarningModalProps {
    close: () => void;
    data: any;
}

const WarningDialog: React.FC<WarningModalProps> = ({ close, data }) => {
    const onActionHandler = () => {
        data.onSave();
        close();
    };

    return (
        <MuiDialogWrapper
            styles={data.styles}
            title={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconStatusAlert />
                    <Typography variant="s18w700" sx={{ ml: 1.5 }}>
                        {data.title}
                    </Typography>
                </Box>
            }
            onClose={close}
            content={<Box sx={{ whiteSpace: 'pre-wrap' }}>{data.message}</Box>}
            buttons={[
                {
                    color: 'secondary',
                    name: i18n.translate('Cancel'),
                    onClick: close,
                },
                {
                    name: data.actionBtnText,
                    disabled: data.actionBtnDisabled,
                    onClick: onActionHandler,
                },
            ]}
        />
    );
};

export default WarningDialog;
